const addAllFilterToEachFilterCategory = ({ filterCategory, _acc }) => {
  if (filterCategory === 'themes') _acc[filterCategory]['All Themes'] = true;
};

export default addAllFilterToEachFilterCategory;
